import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipDataResolver } from '../resolvers';
import { SubscriptionDataResolver } from '@b2b/common/resolvers/subscription-data.resolver';
import { FormResponsesByMembershipDataResolver } from '@b2b/common/resolvers/forms-responses-data.resolver';
import { MembershipDetailControllerModule } from './controllers/MembershipDetailController';
import { MembershipDetailMemberView } from './member/member';

export const MembershipDetailView = angular
  .module('acme.view.application.membership.detail', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.directive.detailList',
    MembershipDetailControllerModule,
    MembershipDetailMemberView,
  ])

  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.membership.detail',
      url: '/:id/detail?searchName',
      views: {
        'subview-main': {
          controller: 'MembershipDetailController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/detail/detail.tpl.html',
        },
      },
      data: {
        pageTitle: 'Membership Details',
        enablePreferences: true,
      },
      resolve: {
        SubscriptionData: SubscriptionDataResolver(),
        MembershipData: MembershipDataResolver(),
        FormResponsesByMembershipData: FormResponsesByMembershipDataResolver(),
      },
    });
  }).name;
